import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const gitHash = (process.env.REACT_APP_GIT_SHA || '').slice(0, 6);
  const buildLabel = `Build ${gitHash || process.env.REACT_APP_STAGE || 'dev'}`;
  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 2,
        px: { xs: 2, md: 4 },
        backgroundColor: theme => theme.palette.grey[100],
        borderTop: theme => `1px solid ${theme.palette.grey[300]}`,
        position: 'relative',
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ textAlign: 'center', textTransform: 'none' }}
      >
        © {currentYear} Veravas, Inc. All rights reserved. VeraBIND (TM) is a trademark of Veravas, Inc.
        <> | {buildLabel} | </>
        <MuiLink
          href="mailto:info@veravas.com"
          sx={{
            color: '#0B6D6D',
            fontWeight: 600,
            '&:hover': { color: '#084F4F' },
          }}
        >
          info@veravas.com
        </MuiLink>{' '}
        |{' '}
        <MuiLink
          href="https://www.veravas.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: '#0B6D6D',
            fontWeight: 600,
            '&:hover': { color: '#084F4F' },
          }}
        >
          www.veravas.com
        </MuiLink>
      </Typography>
    </Box>
  );
}
